import ConfigListItem from './ConfigListItem.vue';

export default ConfigListItem;
